<template>
    <dl class="flex grow space-between gap-x-4 gap-y-4">
        <slot />
    </dl>
</template>

<script setup lang="ts"></script>
